import React from 'react';

export type HeadingLevelContextType = {
  level: number;
  children?: React.ReactNode;
};

// Components within `common-components` and `design-system` both need
// a reference to this exact context object. However there are circular
// dependency issues between those packages, so this context object exists
// in its own package.
const HeadingLevelContext: React.Context<HeadingLevelContextType> =
  React.createContext({
    level: 1,
  });

export const useHeadingLevel = () => React.useContext(HeadingLevelContext);

export const HeadingLevelProvider = ({
  level = 1,
  children,
}: HeadingLevelContextType) => {
  return (
    <HeadingLevelContext.Provider
      value={{
        level,
      }}
    >
      {children}
    </HeadingLevelContext.Provider>
  );
};
